import { DatePipe, isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { faExpand } from '@fortawesome/free-solid-svg-icons';
import { Subject, takeUntil } from 'rxjs';
import { FinancialBackendService } from 'src/app/core/services/financial-backend.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-coin-chart',
  templateUrl: './coin-chart.component.html',
  styleUrls: ['./coin-chart.component.scss']
})
export class CoinChartComponent implements OnInit {
  faExpand = faExpand;
  @Input('code') code: string;
  iframeSource: SafeResourceUrl;
  todayDate: string;
  destroy$: Subject<boolean> = new Subject<boolean>();
  isBrowser:any;
  constructor(
    private sanitizer: DomSanitizer,
    private financialBackendService: FinancialBackendService,
    private datePipe: DatePipe,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.todayDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
  }

  ngOnInit(): void {
    this.isBrowser=isPlatformBrowser(this.platformId)
    if(this.isBrowser){
      this.changeIframeSrc(this.code);
    }
  }

  changeIframeSrc(code: string) {
    if(code.length<6){
      this.financialBackendService
        .getCoinChartWithVolume(this.code, this.todayDate, this.code, 'html')
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (pagedData) => {
            this.iframeSource = this.sanitizer.bypassSecurityTrustResourceUrl(
              environment.domain + '/coin/chart/' + code.toLowerCase() + '.html'
            );
          },
          error: (error) => {
            console.log('error: ', error);
          },
        });
    }
  }
}
